const prefix = 'rsme_';

const setStateId  = (sid) => {
    sessionStorage.setItem(prefix+'state_id', sid);
}

const getStateId = () => {
    return sessionStorage.getItem(prefix+'state_id');
}

const clearAll = () => {
    sessionStorage.clear();
}

const setIsFirstTime = (value) => {
    sessionStorage.setItem(prefix+'first_time', value);
}

const getIsFirstTime = () => {
    return sessionStorage.getItem(prefix+'first_time');
}

const setToken = (token) => {
    sessionStorage.setItem(prefix+'auth_token', token);
}
 
const getToken = () => {
    return sessionStorage.getItem(prefix+'auth_token');
}

const setTokenExpiry = (expiredDate) => {
    sessionStorage.setItem(prefix+'token_expired', expiredDate); 
}

const getTokenExpiry = () => {
    return sessionStorage.getItem(prefix+'token_expired');
}

const setFilesArray = (files) => {
    sessionStorage.setItem(prefix+"def_files", JSON.stringify(files));
}

const getFilesArray = () => {
   return JSON.parse(sessionStorage.getItem(prefix+"def_files") || "[]");
}

const setBizConstStatus= (status) => {
    sessionStorage.setItem(prefix+'biz_const', status);
}

const getBizConstStatus = (status) => {
    return sessionStorage.getItem(prefix+'biz_const');
}

const setProductType = (option) => {
    sessionStorage.setItem(prefix+'prod_type', option);
}

const getProductType = (status) => {
    return sessionStorage.getItem(prefix+'prod_type');
}

const setRefNo = (refno) => {
    sessionStorage.setItem(prefix+'ref_no', refno);
}

const getRefNo = () => {
    return sessionStorage.getItem(prefix+'ref_no');
}

const setCompType = (coType)=> {
    sessionStorage.setItem(prefix+'comp_type_code', coType);
}

const getCompType = ()=> {
    return sessionStorage.getItem(prefix+'comp_type_code');
}

const setSHSaved = (value) => {
    sessionStorage.setItem(prefix+'sh_saved', value); //shareholder saved: true/false
}

const getSHSaved = (value) => {
    return sessionStorage.getItem(prefix+'sh_saved'); //shareholder saved: true/false
}

const setIsAPEdited = (value) => {
    sessionStorage.setItem(prefix+'ap_edited', value); // AP Edited: true/false
}

const getIsAPEdited  = (value) => {
    return sessionStorage.getItem(prefix+'ap_edited'); // AP Edited: true/false
}

const setIsLoginUserShareholder = (value) => {
    sessionStorage.setItem(prefix+'is_lg_SH',value);
}

const getIsLoginUserShareholder = (value) => {
    return sessionStorage.getItem(prefix+'is_lg_SH');
}

const setFromSource = (value) => {
    sessionStorage.setItem(prefix+'p_src',value);
}

const getFromSource = (value) => {
    return sessionStorage.getItem(prefix+'p_src');
}

export default {
    setStateId,
    getStateId,
    setToken,
    getToken,
    setTokenExpiry,
    getTokenExpiry,
    setFilesArray,
    getFilesArray,
    setBizConstStatus,
    getBizConstStatus,
    setProductType,
    getProductType,
    setIsFirstTime,
    getIsFirstTime,
    setRefNo,
    getRefNo,
    setCompType,
    getCompType,
    setSHSaved,
    getSHSaved,
    setIsAPEdited,
    getIsAPEdited,
    setIsLoginUserShareholder,
    getIsLoginUserShareholder,
    setFromSource,
    getFromSource,
    clearAll 
}; 